import "./login.css";
import React, { useState, useEffect } from "react";
import ThemeSwitch from "../../Components/themeSwitch/themeSwitch";

import CustomerLeftPanel from "../../Components/CustomerLeftPanel/customer-left-panel";

const LoginPage = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState(""); // State to store email
  const [rememberMe, setRememberMe] = useState(false); // State to store "remember me" checkbox state
  const [error, setError] = useState("");

  const togglePassword = () => {
    setShowPassword((prevState) => !prevState);
  };

  const images = ["/login.png", "/login.png", "/login.png"];


  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email format
    return emailRegex.test(email);
  };

  // Password validation
  const validatePassword = (password) => {
    return password.length >= 8; // Password must be at least 8 characters long
  };
  const postLoginAPI = async (email, password) => {
    const apiUrl = "https://your-api-url.com/login"; // Replace with your API URL
    const bodyData = {
      email: email,
      password: password,
    };

    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(bodyData),
    });

    return response.json(); // Return the response data
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateEmail(email)) {
      setError("Please enter a valid email address.");
      return;
    }
    if (!validatePassword(password)) {
      setError("Password must be at least 8 characters long.");
      return;
    }
    setError("");
    try {
      const response = await postLoginAPI(email, password);

      if (response.success) {
        alert("Login successful");
      } else {
        setError(response.message);
      }
    } catch (err) {
      setError("An error occurred during login. Please try again later.");
    }
  };

  return (
    <div className="flex flex-col lg:flex-row h-screen dark:bg-[#101010] bg-[#FFFFFF]">
    <CustomerLeftPanel />
      {/* Right side */}
      <div className="w-full lg:w-1/2 flex flex-col">
        <ThemeSwitch />
        <div className="flex  flex-col mt-10 justify-center items-center md:p-0 p-10 justify">
          <h2 className="text-2xl mb-[32px] dark:text-white font-medium  mb-6">
            Log in to Caprock
          </h2>
          <form className="w-full max-w-sm" onSubmit={handleSubmit}>
            <div className="mb-4">
              <label
                htmlFor="email"
                className="block dark:text-gray-300 font-normal color-test text-md mb-1"
              >
                Email
              </label>
              <input
                id="email"
                name="email"
                type="text"
                value={email}
                required={true}
                className="input-field dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                placeholder="name@email.com"
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="mb-4 relative">
              <label
                htmlFor="password"
                className="block color-test dark:text-gray-300 font-normal color-test text-md mb-1"
              >
                Password
              </label>
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                required={true}
                id="password"
                onChange={(e) => setPassword(e.target.value)}
                className="dark:bg-[#101010] dark:border-[#4F4F4F] input-field appearance-none border w-full py-2 px-3  dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium leading-tight focus:outline-none focus:shadow-outline"
                placeholder="Type password"
              />
              <button
                type="button"
                onClick={togglePassword}
                className="absolute right-3 set-top"
              >
                {" "}
                {showPassword ? (
                  <img src="/eye.svg" alt="Logo" className="h-auto" />
                ) : (
                  <img src="/eye-slash.svg" alt="Logo" className="h-auto" />
                )}
              </button>
              <div className="flex items-center pt-4 justify-between mb-6">
                <div className="flex items-center"></div>
                <a
                  href="#"
                  className=" text-sm font-medium  after-login hover:underline"
                >
                  Forgot Password?
                </a>
              </div>
            </div>
            <button
              type="submit"
              className="w-full dark:bg-[#424242] dark:hover:bg-[#424242e6] bg-black text-white font-medium text-sm py-3 rounded-full flex items-center justify-center gap-2 hover:bg-white-600 transition duration-300"
            >
              <img
                src="/profile-circle.svg"
                alt="Login Icon"
                className="h-6 w-6"
              />
              Log in
            </button>
          </form>
          <div className="mt-6 w-full max-w-sm text-center">
            <img src="/line.svg" alt="Logo" className="h-auto" />

            <p className="text-labelColour dark:text-[#CCCCCC] font-medium pt-2">
              Don’t have an account?{" "}
              <button
                type="submit"
                className="w-full dark:bg-[#101010] dark:text-white dark:border-[#424242] mt-2 signup-button text-black font-medium text-sm py-3 rounded flex items-center justify-center gap-2 hover:bg-[#F1F5F9] dark:hover:bg-[#1E293B]  transition duration-300"
              >
                <img
                  src="/user-circle-add.svg"
                  alt="Login Icon"
                  className="h-6 w-6 dark:hidden"
                />
                <img
                  src="/user-circle-add-dark.png"
                  alt="Login Icon"
                  className="hidden dark:inline-block h-6 w-6"
                />
                Sign up
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default LoginPage;
